import { default as AccordionField } from '../AccordionField';
import { default as BaseObjectField } from '../BaseObjectField';
import { default as FieldsetField } from '../FieldsetField';
import { default as NumberField } from '../NumberField';
import { default as SchemaField } from '../SchemaField';
import { default as StringField } from '../StringField';
import { default as TabField } from './TabField';
import { default as TabsField } from './TabsField';
import { default as TableField } from './TableField';
import { default as TableRowField } from './TableRowField';

export { default as AccordionField } from '../AccordionField';
export { default as BaseObjectField } from '../BaseObjectField';
export { default as FieldsetField } from '../FieldsetField';
export { default as NumberField } from '../NumberField';
export { default as SchemaField } from '../SchemaField';
export { default as StringField } from '../StringField';
export { default as TabField } from './TabField';
export { default as TabsField } from './TabsField';
export { default as TableField } from './TableField';
export { default as TableRowField } from './TableRowField';

export const fields = {
  accordion: AccordionField,
  fieldset: FieldsetField,
  integer: NumberField,
  number: NumberField,
  object: BaseObjectField,
  SchemaField,
  StringField,
  tab: TabField,
  tabs: TabsField,
  table: TableField,
  tablerow: TableRowField,
};


// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/readonly/index.js